export default __webpack_public_path__ + "static/media/goodafternoon.3ed951ca.mpga";